"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataPairingStatsDTO_1 = require("../../model/dto/DataPairingStatsDTO");

var DataPairingStatsDTOConverter_1 = require("./DataPairingStatsDTOConverter");
/**
 * Implementation of DataPairingStatsDTOConverterImpl
 *
 * @author RV
 */


var DataPairingStatsDTOConverterImpl =
/*#__PURE__*/
function (_DataPairingStatsDTOC) {
  _inherits(DataPairingStatsDTOConverterImpl, _DataPairingStatsDTOC);

  function DataPairingStatsDTOConverterImpl() {
    _classCallCheck(this, DataPairingStatsDTOConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(DataPairingStatsDTOConverterImpl).apply(this, arguments));
  }

  _createClass(DataPairingStatsDTOConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      return new DataPairingStatsDTO_1.DataPairingStatsDTO(source.categoryId, source.numberOfRecommended, source.numberOfUnpaired);
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, {
        categoryId: source.categoryId,
        numberOfRecommended: source.numberOfRecommended,
        numberOfUnpaired: source.numberOfUnpaired
      });
      return result;
    }
  }]);

  return DataPairingStatsDTOConverterImpl;
}(DataPairingStatsDTOConverter_1.DataPairingStatsDTOConverter);

exports.DataPairingStatsDTOConverterImpl = DataPairingStatsDTOConverterImpl;